import { FiType } from 'react-icons/fi';

import Input from '@components/Input';

import { FieldRendererProps } from '../types';

const TextField = ({ field, disabled }: FieldRendererProps) => (
  <Input
    name={field.name}
    placeholder={field.placeholder || field.label}
    icon={FiType}
    disabled={disabled}
    required={field.is_required}
  />
);

export default TextField;
